// import { NavLink, useLocation } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "../home/Home.css";
// import "../home/Responsive.css";
// import "bootstrap-icons/font/bootstrap-icons.css";

// import React, { useState, useEffect, useRef } from "react";
// import { useDispatch } from "react-redux";
// import { logout } from "../redux/slices/authSlice";
// import { useNavigate } from "react-router-dom";

// import AuthModal from "../auth/AuthModal";
// import GuideAuth from "../auth/GuideAuth";
// import { getUserData, removeUserData } from "../utils/storage";
// import { userLogout } from "../services/authService";

// import ReusableModal from "../common/ReusableModal";
// import { clearGuideAuth, clearUserAuth } from "../utils/authStorage";

// function Header() {
//   const user = getUserData("safarix_user");
//   const guide = getUserData("guide");
//   const driver = getUserData("driver");

//   const [showProfileMenu, setShowProfileMenu] = useState(false);
//   const [showUserLogin, setShowUserLogin] = useState(false);
//   const [isSticky, setIsSticky] = useState(false);
//   const [showLogoutModal, setShowLogoutModal] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const profileMenuRef = useRef(null);
//   const location = useLocation();

//   const isTransparentHeader =
//     location.pathname === "/" || location.pathname === "/hotel";

//   const handleProfileClick = () => {
//     if (user) {
//       navigate("/user-dashboard", { replace: true });
//     } else if (guide) {
//       navigate("/guide-dashboard", { replace: true });
//     } else {
//       setShowUserLogin(!showUserLogin);
//     }
//   };

//   const handleLogoutClick = () => {
//     setShowLogoutModal(true);
//   };

//   const confirmLogout = () => {
//     if (user) {
//       dispatch(logout());
//       clearUserAuth();
//     } else if (guide) {
//       clearGuideAuth();
//       dispatch(logout());
//     } else {
//       console.log("error in user logout");
//     }
//     setShowLogoutModal(false);
//     window.location.reload(true);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         profileMenuRef.current &&
//         !profileMenuRef.current.contains(event.target)
//       ) {
//         setShowProfileMenu(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     if (!isTransparentHeader) return;

//     const handleScroll = () => {
//       setIsSticky(window.scrollY > 50);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [isTransparentHeader]);

//   return (
//     <div>

//       <header className="main-header sticky-top">

//         {/* Top Header */}
//         <div className="top-header">
//           <div className="container">
//             <div className="top-header-content">
//               <span>
//                 <i className="bi bi-headset me-2"></i>
//                 Support: 9821373111 - 24/7, 365 days a year!
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Main Navbar */}
//         <div className="main-navbar">
//           <div className="container">

//             {/* Top Row */}
//             <div className="d-flex align-items-center justify-content-between">

//               {/* Logo */}
//               <a className="navbar-brand" href="/">
//                 <img
//                   src="/Images/black-logo.png"
//                   alt="Safarix Logo"
//                   height="45"
//                 />
//               </a>

//               {/* Desktop Navigation */}
//               <ul className="nav header-nav d-none d-md-flex">

//                 {/* FLIGHT */}
//                 <li className="nav-item">
//                   <NavLink
//                     to="/flights"
//                     className={({ isActive }) =>
//                       "nav-link " +
//                       (isActive || location.pathname.startsWith("/flights") || location.pathname.startsWith("/flight")
//                         ? "active"
//                         : "")
//                     }
//                   >
//                     <i className="bi bi-airplane"></i> FLIGHT
//                   </NavLink>
//                 </li>

//                 {/* HOTEL */}
//                 <li className="nav-item">
//                   <NavLink
//                     to="/hotel"
//                     className={({ isActive }) =>
//                       "nav-link " +
//                       (isActive || location.pathname.startsWith("/hotel")
//                         ? "active"
//                         : "")
//                     }
//                   >
//                     <i className="bi bi-building"></i> HOTEL
//                   </NavLink>
//                 </li>

//                 {/* BUS */}
//                 <li className="nav-item">
//                   <NavLink
//                     to="/bus"
//                     className={({ isActive }) =>
//                       "nav-link " +
//                       (isActive ||
//                         location.pathname.startsWith("/bus") ||
//                         location.pathname.startsWith("/bus-list") ||
//                         location.pathname.startsWith("/Bus-checkout")
//                         ? "active"
//                         : "")
//                     }
//                   >
//                     <i className="bi bi-bus-front-fill"></i> BUS
//                   </NavLink>
//                 </li>

//               </ul>

//               {/* Profile */}
//               <div className="d-flex align-items-center">
//                 <div className="profile-wrapper me-2" ref={profileMenuRef}>
//                   <div className="profile-icon-link" onClick={handleProfileClick}>
//                     <i className="bi bi-person"></i>
//                   </div>
//                 </div>

//                 {(user || guide) && (
//                   <div onClick={handleLogoutClick} className="profile-icon-link">
//                     <i className="bi bi-box-arrow-right"></i>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Mobile Navigation */}
//             <div className="row g-2 mt-2 d-md-none">

//               {/* FLIGHT */}
//               <div className="col-4">
//                 <NavLink
//                   to="/flights"
//                   className={({ isActive }) =>
//                     "mobile-nav-card " +
//                     (isActive ||
//                       location.pathname.startsWith("/flights") ||
//                       location.pathname.startsWith("/flight")
//                       ? "active"
//                       : "")
//                   }
//                 >
//                   <i className="bi bi-airplane"></i>
//                   <span>FLIGHT</span>
//                 </NavLink>
//               </div>

//               {/* HOTEL */}
//               <div className="col-4">
//                 <NavLink
//                   to="/hotel"
//                   className={({ isActive }) =>
//                     "mobile-nav-card " +
//                     (isActive ||
//                       location.pathname.startsWith("/hotel")
//                       ? "active"
//                       : "")
//                   }
//                 >
//                   <i className="bi bi-building"></i>
//                   <span>HOTEL</span>
//                 </NavLink>
//               </div>

//               {/* BUS */}
//               <div className="col-4">
//                 <NavLink
//                   to="/bus"
//                   className={({ isActive }) =>
//                     "mobile-nav-card " +
//                     (isActive ||
//                       location.pathname.startsWith("/bus") ||
//                       location.pathname.startsWith("/bus-list") ||
//                       location.pathname.startsWith("/Bus-checkout")
//                       ? "active"
//                       : "")
//                   }
//                 >
//                   <i className="bi bi-bus-front"></i>
//                   <span>BUS</span>
//                 </NavLink>
//               </div>

//             </div>

//             <AuthModal
//               show={showUserLogin}
//               onClose={() => setShowUserLogin(false)}
//               setShowUserLogin={setShowUserLogin}
//             />

//           </div>
//         </div>
//       </header>

//       <ReusableModal
//         show={showLogoutModal}
//         onHide={() => setShowLogoutModal(false)}
//         title="Confirm Logout"
//         message="Are you sure you want to logout?"
//         okText="Yes, Logout"
//         cancelText="Cancel"
//         onOk={confirmLogout}
//       />
//     </div>
//   );
// }

// export default Header;

import { NavLink, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../home/Home.css";
import "../home/Responsive.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";

import AuthModal from "../auth/AuthModal";
import GuideAuth from "../auth/GuideAuth";
import { getUserData, removeUserData } from "../utils/storage";
import { userLogout } from "../services/authService";

import ReusableModal from "../common/ReusableModal";
import { clearGuideAuth, clearUserAuth } from "../utils/authStorage";

function Header() {
  const user = getUserData("safarix_user");
  const guide = getUserData("guide");
  const driver = getUserData("driver");

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showUserLogin, setShowUserLogin] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileMenuRef = useRef(null);
  const location = useLocation();

  const isTransparentHeader =
    location.pathname === "/" || location.pathname === "/hotel";

  const handleProfileClick = () => {
    if (user) {
      navigate("/user-dashboard", { replace: true });
    } else if (guide) {
      navigate("/guide-dashboard", { replace: true });
    } else {
      setShowUserLogin(!showUserLogin);
    }
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    if (user) {
      dispatch(logout());
      clearUserAuth();
    } else if (guide) {
      clearGuideAuth();
      dispatch(logout());
    } else {
      console.log("error in user logout");
    }
    setShowLogoutModal(false);
    window.location.reload(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isTransparentHeader) return;

    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isTransparentHeader]);

  return (
    <div>

      <header className="main-header sticky-top">

        {/* Top Header */}
        <div className="top-header">
          <div className="container">
            <div className="top-header-content">
              <span>
                <i className="bi bi-headset me-2"></i>
                Support: 9821373111 - 24/7, 365 days a year!
              </span>
            </div>
          </div>
        </div>

        {/* Main Navbar */}
        <div className="main-navbar">
          <div className="container">

            {/* Top Row */}
            <div className="d-flex align-items-center justify-content-between">

              {/* Logo */}
              <a className="navbar-brand" href="/">
                <img
                  src="/Images/black-logo.png"
                  alt="Safarix Logo"
                  height="45"
                />
              </a>

              {/* Desktop Navigation */}
              <ul className="nav header-nav d-none d-md-flex">

                {/* FLIGHT */}
                <li className="nav-item">
                  <NavLink
                    to="/flights"
                    className={({ isActive }) =>
                      "nav-link " +
                      (isActive || location.pathname.startsWith("/flights") || location.pathname.startsWith("/flight")
                        ? "active"
                        : "")
                    }
                  >
                    <i className="bi bi-airplane"></i> FLIGHT
                  </NavLink>
                </li>

                {/* HOTEL */}
                <li className="nav-item">
                  <NavLink
                    to="/hotel"
                    className={({ isActive }) =>
                      "nav-link " +
                      (isActive || location.pathname.startsWith("/hotel")
                        ? "active"
                        : "")
                    }
                  >
                    <i className="bi bi-building"></i> HOTEL
                  </NavLink>
                </li>

                {/* BUS */}
                <li className="nav-item">
                  <NavLink
                    to="/bus"
                    className={({ isActive }) =>
                      "nav-link " +
                      (isActive ||
                        location.pathname.startsWith("/bus") ||
                        location.pathname.startsWith("/bus-list") ||
                        location.pathname.startsWith("/Bus-checkout")
                        ? "active"
                        : "")
                    }
                  >
                    <i className="bi bi-bus-front-fill"></i> BUS
                  </NavLink>
                </li>

                {/* GUIDE */}
                <li className="nav-item">
                  <NavLink
                    to="/guides"
                    className={({ isActive }) =>
                      "nav-link " +
                      (isActive || location.pathname.startsWith("/guide")
                        ? "active"
                        : "")
                    }
                  >
                    <i className="bi bi-person-badge"></i> GUIDE
                  </NavLink>
                </li>

              </ul>

              {/* Profile */}
              <div className="d-flex align-items-center">
                <div className="profile-wrapper me-2" ref={profileMenuRef}>
                  <div className="profile-icon-link" onClick={handleProfileClick}>
                    <i className="bi bi-person"></i>
                  </div>
                </div>

                {(user || guide) && (
                  <div onClick={handleLogoutClick} className="profile-icon-link">
                    <i className="bi bi-box-arrow-right"></i>
                  </div>
                )}
              </div>
            </div>

            {/* Mobile Navigation */}
            <div className="row g-2 mt-2 d-md-none">

              {/* FLIGHT */}
              <div className="col-3">
                <NavLink
                  to="/flights"
                  className={({ isActive }) =>
                    "mobile-nav-card " +
                    (isActive ||
                      location.pathname.startsWith("/flights") ||
                      location.pathname.startsWith("/flight")
                      ? "active"
                      : "")
                  }
                >
                  <i className="bi bi-airplane"></i>
                  <span>FLIGHT</span>
                </NavLink>
              </div>

              {/* HOTEL */}
              <div className="col-3">
                <NavLink
                  to="/hotel"
                  className={({ isActive }) =>
                    "mobile-nav-card " +
                    (isActive ||
                      location.pathname.startsWith("/hotel")
                      ? "active"
                      : "")
                  }
                >
                  <i className="bi bi-building"></i>
                  <span>HOTEL</span>
                </NavLink>
              </div>

              {/* BUS */}
              <div className="col-3">
                <NavLink
                  to="/bus"
                  className={({ isActive }) =>
                    "mobile-nav-card " +
                    (isActive ||
                      location.pathname.startsWith("/bus") ||
                      location.pathname.startsWith("/bus-list") ||
                      location.pathname.startsWith("/Bus-checkout")
                      ? "active"
                      : "")
                  }
                >
                  <i className="bi bi-bus-front"></i>
                  <span>BUS</span>
                </NavLink>
              </div>

              {/* GUIDE */}
              <div className="col-3">
                <NavLink
                  to="/guides"
                  className={({ isActive }) =>
                    "mobile-nav-card " +
                    (isActive || location.pathname.startsWith("/guide")
                      ? "active"
                      : "")
                  }
                >
                  <i className="bi bi-person-badge"></i>
                  <span>GUIDE</span>
                </NavLink>
              </div>

            </div>

            <AuthModal
              show={showUserLogin}
              onClose={() => setShowUserLogin(false)}
              setShowUserLogin={setShowUserLogin}
            />

          </div>
        </div>
      </header>

      <ReusableModal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        okText="Yes, Logout"
        cancelText="Cancel"
        onOk={confirmLogout}
      />
    </div>
  );
}

export default Header;